<script>
import { richTextImgHandler } from '@/utils/common'

import {
  getHyPbDetail,
  getPbDetail,
  getMigrantService,
  getPartyBranchDrop,
  getPartyBranch } from '@/api/partyTop'

import MenuList from '../components/MenuList.vue'
import DropList from 'comp/common/DropList.vue'
import NoData from 'comp/common/NoData/index.vue'

export default {
  components: { MenuList, DropList, NoData },
  data() {
    return {
      loading: false,
      moduleName: '',
      titleid: '',
      dataId: 0,
      village: localStorage.getItem('currentCommunity') || '',
      pageData: [],
      tabActive: 0,
      pagerConfig: {
        currentPage: 1,
        pageSize: 0,
        total: 0
      },
      dropOption: [],
      currentDropIdx: 0,
      dropIsShow: false
    }
  },
  computed: {
    currentMemo() {
      return this.pageData.filter((item, idx) => this.tabActive === idx)[0] || {}
    }
  },
  watch: {
    currentMemo(newVal) {
      if (JSON.stringify(newVal) !== '{}') {
        this.$nextTick(() => {
          setTimeout(() => {
            const parent = document.querySelector('.left-memo')
            parent.scrollTo({ top: 0, behavior: 'smooth' })
          }, 200)
        })
      }
    }
  },
  created() {
    const { label = '', titleid = 0, id = 0 } = this.$route.query
    this.moduleName = label
    this.titleid = titleid
    this.dataId = id
    const hy_whitelist = ['洪雅党史', '先进事迹', '乡村振兴']
    const rural_whitelist = ['活动开展', '服务保障', '风采展示']
    const partyBranch_whitelist = ['青年党支部', '维权帮助']
    if (label === '党建洪雅') {
      this.dropIsShow = false
      this.getHyPbDetailData()
    }
    if (hy_whitelist.includes(label)) {
      this.dropIsShow = false
      this.initPageData()
    }
    if (rural_whitelist.includes(label)) {
      this.dropIsShow = false
      this.getMigrantServiceData()
    }
    if (partyBranch_whitelist.includes(label)) {
      this.dropIsShow = true
      this.getPartyBranchDropData()
    }
  },
  methods: {
    richTextImgHandler,
    onPageBack() {
      this.$router.go(-1)
    },
    onTabClick(id) {
      this.pageData.forEach((item, idx) => {
        if (id === item.id) this.tabActive = idx
      })
    },
    onPagerChange(currentPage) {
      this.pagerConfig.currentPage = currentPage
      this.tabActive = 0
      this.getHyPbDetailData()
    },
    onDropClick(val) {
      this.dropOption.forEach((item, idx) => {
        if (item.label === val.label) this.currentDropIdx = idx
      })
      this.tabActive = 0
      this.moduleName === '维权帮助' ? this.getMigrantServiceData() : this.getPartyBranchData()
    },

    getHyPbDetailData() {
      this.pageData = []
      this.loading = true
      const params = { village: this.village, pager: this.pagerConfig.currentPage }
      getHyPbDetail(params).then(res => {
        const { code, msg = [], count = 0, pagelength = 0 } = res
        if (code === 0) {
          this.pageData = msg || []
          this.pagerConfig.total = count
          this.pagerConfig.pageSize = pagelength
        }
      }).finally(() => {
        this.loading = false
      })
    },
    initPageData() {
      this.pageData = []
      this.loading = true
      const params = {
        titleid: Number(this.titleid),
        title: this.moduleName,
        village: this.village
      }
      getPbDetail(params).then(res => {
        if (res.code === 0) this.pageData = res.msg || []
      }).finally(() => {
        this.loading = false
      })
    },
    getMigrantServiceData() {
      this.pageData = []
      this.loading = true
      const title = this.moduleName === '维权帮助'
        ? this.dropOption.filter((item, idx) => idx === this.currentDropIdx)[0].label
        : this.moduleName
      const params = { title: title, village: this.village }
      getMigrantService(params).then(res => {
        if (res.code === 0) this.pageData = res.msg || []
      }).finally(() => {
        this.loading = false
      })
    },
    getPartyBranchDropData() {
      this.pageData = []
      this.loading = true
      const params = { status: this.moduleName === '青年党支部' ? 1 : 2 }
      getPartyBranchDrop(params).then(res => {
        if (res.code === 0) {
          const townshipArr = []
          res.msg.forEach((item, idx) => {
            townshipArr.push({ label: item.name, value: idx + 1 })
          })
          this.dropOption = townshipArr
          this.moduleName === '维权帮助' ? this.getMigrantServiceData() : this.getPartyBranchData()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getPartyBranchData() {
      this.pageData = []
      this.loading = true
      const params = {
        name: this.dropOption.filter((item, idx) => idx === this.currentDropIdx)[0].label,
        village: this.village
      }
      getPartyBranch(params).then(res => {
        if (res.code === 0) this.pageData = res.msg || []
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<template>
  <div class="page-container">
    <div class="page-logo-container">
      <el-image class="hy-logo" :src="require('imgs/partyTop/hy-logo.png')" alt="hy-logo" />
      <p class="page-title">洪雅智慧党建</p>
    </div>

    <div class="main-container">
      <div class="content-center">
        <div v-if="currentMemo.headline" class="left-memo">
          <p v-if="currentMemo.headline" class="memo-title">{{ currentMemo.headline || '' }}</p>
          <p class="memo-time">{{ currentMemo.createtime | formatDate('yyyy-MM-dd') }}</p>
          <p class="rich-text memo-rich-text" v-html="richTextImgHandler(currentMemo.memo)" />
        </div>
        <p v-if="loading" class="loading-box">
          <i class="el-icon-loading" />
          <span>加载中...</span>
        </p>
        <div v-if="!loading && !currentMemo.headline" class="left-memo">
          <no-data class="no-data-comp" />
        </div>
        <div class="right-menu">
          <p class="menu-title">{{ moduleName }}</p>
          <div class="right-menu-container">
            <menu-list
              :page-data="pageData"
              :tab-active="tabActive"
              :current-drop-idx="currentDropIdx"
              @onTabClick="onTabClick"
            />
            <div v-if="moduleName === '党建洪雅'" class="pb-pagination-box">
              <el-pagination
                background
                :total="pagerConfig.total"
                :page-size="pagerConfig.pageSize"
                :current-page="pagerConfig.currentPage"
                :pager-count="5"
                layout="prev, pager, next"
                @current-change="onPagerChange"
              >
              </el-pagination>
            </div>
            <drop-list
              v-if="dropIsShow"
              :drop-option="dropOption"
              :selected-index="currentDropIdx"
              class="drop-list-comp"
              @onDropClick="onDropClick"
            />
          </div>
        </div>
      </div>
    </div>

    <el-image
      :src="require('imgs/partyTop/party-building/return.png')"
      alt="return"
      class="return-img"
      @click="onPageBack"
    />
  </div>
</template>

<style lang="scss" scoped>
.page-container {
  width: 100%;
  min-height: 100vh;
  // background: fff;
  background: url('~imgs/partyTop/party-building/detail-bg.webp') no-repeat center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  position: relative;
  .page-logo-container {
    position: absolute;
    top: 26px;
    left: 26px;
    display: flex;
    column-gap: 16px;
    .hy-logo {
      width: 87px;
      height: 50px;
    }
    .page-title {
      font-size: 24px;
      font-weight: bold;
      color: #fff;
      margin-top: 2px;
      letter-spacing: 3px;
    }
  }
  .return-img {
    position: absolute;
    width: 132px;
    height: 52px;
    bottom: 0;
    left: 894px;
    cursor: pointer;
  }
}
.main-container {
  width: 1535px;
  height: 790px;
  background: url('~imgs/partyTop/party-building/detail-shadow.png') no-repeat bottom;
  background-size: 1535px 768px;
  display: flex;
  justify-content: center;
  margin-top: 136px;
  .content-center {
    width: 1505px;
    height: 775px;
    background: #fff;
    border-radius: 30px;
    padding: 40px 40px 40px 90px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    .left-memo {
      width: 920px;
      height: 695px;
      margin-right: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;

      // overflow-y: scroll;
      // overflow-x: hidden;
      // &::-webkit-scrollbar {
      //   width: 6px;
      // }
      // &::-webkit-scrollbar-track {
      //   border-radius: 3px;
      // }
      // &::-webkit-scrollbar-thumb {
      //   background: #C1C1C1;
      //   border-radius: 3px;
      // }
      overflow-y: scroll;
      &::-webkit-scrollbar { // chrome/safari
        display: none;
      }
      scrollbar-width: none; // firefox
      -ms-overflow-style: none; // IE10+
      .memo-title {
        width: 640px;
        font-size: 27px;
        font-weight: bold;
        color: #0E2232;
        text-align: center;
      }
      .memo-time {
        font-size: 15px;
        color: #A4A8AB;
        margin-top: 30px;
      }
      .memo-rich-text {
        max-width: 900px;
        margin-top: 40px;
      }
    }
    .loading-box {
      width: 920px;
      text-align: center;
      font-size: 20px;
      margin-top: 140px;
      .el-icon-loading {
        font-size: 20px;
        font-weight: bold;
        margin-right: 6px;
      }
    }
    .right-menu {
      .menu-title {
        width: 324px;
        height: 70px;
        background: url('~imgs/partyTop/party-building/detail-title-bg.png') no-repeat center;
        background-size: 100% 100%;
        font-size: 24px;
        font-family: siyuansong;
        font-weight: 800;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .right-menu-container {
        margin-top: 16px;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        position: relative;
        .drop-list-comp {
          position: absolute;
          bottom: 0;
        }
      }
    }
  }
}
.no-data-comp {
  margin-top: 100px;
}
</style>
<style lang="scss">
.pb-pagination-box {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #E62129;
    color: #fff;
  }
  .el-pagination .el-pager li:not(.disabled):hover {
    color: #E62129;
  }
}
</style>
